import { getItem, setItem } from './storage';

const DateStampKey = 'lqaAcademyPopupDateStamp';
export const  shouldShowLqaAcademyModal = (): boolean =>  {
  const userData = getItem('user');
  const user = userData && userData.user;
  if (!user || !user.id) {
    return true;
  }
  const today = new Date().toISOString().split('T')[0];
  let storedList = getItem(DateStampKey);

  if (!Array.isArray(storedList)) {
    try {
      storedList = JSON.parse(storedList || '[]');
    } catch (event) {
      storedList = [];
    }
  }

  const userEntry = storedList.find((entry) => {
    return entry.id === user.id;
  });

  return !userEntry || userEntry.date !== today;
};

export const addUserAndDateStamp = () => {
  const userData = getItem('user');
  const user = userData && userData.user;

  if (!user || !user.id) {
    return;
  }
  const today = new Date().toISOString().split('T')[0];
  let storedData = getItem(DateStampKey);
  if (!Array.isArray(storedData)) {
    try {
      storedData = JSON.parse(storedData || '[]');
    } catch (event) {
      storedData = [];
    }
  }

  const userIndex = storedData.findIndex((entry) => entry.id === user.id);
  if (userIndex === -1) {
    storedData.push({ id: user.id, date: today });
  } else if (storedData[userIndex].date !== today) {
    storedData[userIndex].date = today;
  }

  setItem(DateStampKey, JSON.stringify(storedData));
};
